const ticker_els = document.getElementsByClassName('js-increment2');

function get_options(el, default_opts) {
  const opts = {};
  function set_opt(attr, opt_name) {
    if (el.hasAttribute(attr)) {
      opts[opt_name] = el.getAttribute(attr);
    }
  }
  set_opt('data-js-increment2-currency', 'currency');
  set_opt('data-js-increment2-duration-ms', 'duration_ms');
  set_opt('data-js-increment2-delay', 'delay');
  set_opt('data-js-increment2-active-classes', 'el_active_classes');
  set_opt('data-js-increment2-span-styles', 'span_styles');
  set_opt('data-js-increment2-span-classes', 'span_classes');
  set_opt('data-js-increment2-retain-space', 'retain_space');
  opts.target_value = parseFloat(el.innerHTML.replace(/,/g, ''));
  return Object.assign({}, default_opts, opts);
}

function ease_out_quint(t) {
  return (t=t-1)*t*t*t*t + 1;
}

function reserve_space(el) {
  const js_el = el.cloneNode(true);
  js_el.classList.remove('js-increment2');
  Object.assign(el.style, {
    position: 'relative',
    color: 'transparent',
  });
  Object.assign(js_el.style, {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
  });
  js_el.style.removeProperty('color');
  js_el.innerHTML = '';
  el.appendChild(js_el);
  return js_el;
}

function print_number(el, count, opts) {
  const regex = /\B(?=(\d{3})+(?!\d))/g; // used to add a "," for style
  const number = (opts.currency ? opts.currency : '') + (count).toFixed(0).toString().replace(regex, ',');
  function spanify_number(str, tmpl) {
    return str.replace(/\S/g, tmpl || `<span class="${opts.span_classes}" style="${opts.span_styles}">$&</span>`);
  }
  el.innerHTML = spanify_number(number);
}

const default_opts = {
  currency: null,
  duration_ms: 4000,
  start_value: 0,
  el_active_classes: '',
  span_styles: '',
  span_classes: '',
  retain_space: true,
};

function init_item(el) {
  const opts = get_options(el, default_opts);
  let js_el = null;

  if (opts.el_active_classes) {
    const active_classes = opts.el_active_classes.split(/[ ,]+/).filter(Boolean);
    el.classList.add(...active_classes);
  }

  if (opts.retain_space) {
    js_el = reserve_space(el);
  }

  let initialised = false;
  let {target_value} = opts;
  let {start_value} = opts;
  let {duration_ms} = opts;
  let current_value;
  let t_start;
  let raf_id;

  function update(raf_time_stamp) {
    if (t_start === null) t_start = raf_time_stamp;
    raf_time_stamp = (raf_time_stamp - t_start) / duration_ms;

    const ease_integer = ease_out_quint(raf_time_stamp);
    current_value = (target_value - start_value) * ease_integer + start_value;
    current_value = Math.min(current_value, target_value);

    if (opts.retain_space) {
      print_number(js_el, current_value, opts);
    }
    else {
      print_number(el, current_value, opts);
    }

    if (current_value.toFixed(0) < target_value) {
      enqueue();
    }
    else {
      unbind_listeners(el);
    }
  }

  function enqueue() {
    raf_id = requestAnimationFrame(update);
  }

  function stop() {
    cancelAnimationFrame(raf_id);
  }

  function play() {
    initialised = true;
    stop();
    t_start = null;
    enqueue();
  }

  function resume() {
    if (initialised) {
      duration_ms = duration_ms * (target_value - current_value) / (target_value - start_value);
      start_value = current_value;
    }
    play();
  }

  function unbind_listeners(el) {
    el.removeEventListener('scrollfx/on', resume);
    el.removeEventListener('scrollfx/off', stop);
  }

  function bind_listeners(el) {
    el.addEventListener('scrollfx/on', resume);
    el.addEventListener('scrollfx/off', stop);
  }
  bind_listeners(el);
}

if (ticker_els.length) {
  Array.from(ticker_els).forEach(init_item);
}
